<div>
  <span [ngClass]="className" style="font-weight: bold" data-testid="countdown-span">{{ countDown | emptyFormat }}</span>
  <img class="stop-icon" *ngIf="invoiceStop" src="/assets/svg/invoice-stop.svg" alt="" />
</div>
